import { useMutation } from "@tanstack/react-query";
import { currencyApi } from "./api.service";

type CurrencyData = {
  amount: number;
  token1: string;
  token2: string;
};

export const useCurrencyExchange = () => {
  return useMutation({
    mutationFn: (currencyData: CurrencyData) =>
      currencyApi.post("/exchange-rate", currencyData),
  });
};
